import { NAME } from './constants';

export const SET_ROUTE = `${NAME}/SET_ROUTE`;
export const CLEAR_ROUTE = `${NAME}/CLEAR_ROUTE`;
